export default () => typeof window !== 'undefined' && window.auth0;
